<template>
  <v-tooltip bottom :disabled="!tooltip">
    <template #activator="{ on, attrs }">
      <v-btn
        icon
        :disabled="disabled"
        :loading="loading"
        class="rmr-icon-btn"
        :class="[ `rmr-icon-btn--${variant}`, `rmr-icon-btn--${size}` ]"
        v-bind="{ ...attrs, ...$attrs }"
        v-on="{ ...on, ...$listeners }"
      >
        <v-icon small>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span v-if="tooltip">{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "RmrIconButton",
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: "neutral",
      validator: (value) => ["edit", "delete", "success", "neutral"].includes(value),
    },
    size: {
      type: String,
      default: "sm",
      validator: (value) => ["xs", "sm"].includes(value),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.rmr-icon-btn {
  border-radius: $rmr-radius-md !important;
  transition:
    transform 0.16s ease,
    box-shadow 0.16s ease,
    background-color 0.16s ease !important;
  box-shadow: none !important;

  &::before {
    opacity: 0 !important;
  }

  &:hover:not(.v-btn--disabled) {
    transform: translateY(-1px);
  }

  &--edit {
    background: $rmr-rpm-soft !important;

    .v-icon {
      color: $rmr-rpm-dark !important;
    }

    &:hover:not(.v-btn--disabled) {
      background: $rmr-rpm-tint !important;
      box-shadow: 0 8px 16px rgba($rmr-rpm, 0.22) !important;
    }
  }

  &--delete {
    background: $rmr-red-bg !important;

    .v-icon {
      color: $rmr-red !important;
    }

    &:hover:not(.v-btn--disabled) {
      background: darken($rmr-red-bg, 4%) !important;
      box-shadow: 0 8px 16px rgba($rmr-red, 0.22) !important;
    }
  }

  &--success {
    background: $rmr-green-bg !important;

    .v-icon {
      color: $rmr-green !important;
    }

    &:hover:not(.v-btn--disabled) {
      background: darken($rmr-green-bg, 4%) !important;
      box-shadow: 0 8px 16px rgba($rmr-green, 0.22) !important;
    }
  }

  &--neutral {
    background: $rmr-surface-2 !important;

    .v-icon {
      color: $rmr-text-secondary !important;
    }

    &:hover:not(.v-btn--disabled) {
      background: $rmr-border-hover !important;
      box-shadow: 0 8px 16px rgba($rmr-text-subtle, 0.18) !important;
    }
  }

  &.v-btn--disabled {
    opacity: 0.45 !important;
    pointer-events: auto !important;
    cursor: not-allowed !important;
  }

  &--sm {
    width: 32px !important;
    height: 32px !important;
  }

  &--xs {
    width: 26px !important;
    height: 26px !important;
  }
}
</style>
